module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['map-wrap', {
      'shift-right': _vm.shiftMap
    }],
    on: {
      "click": _vm.clearDestinations
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": _vm.viewBox,
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "height": "100%",
      "width": "100%"
    }
  }, [(_vm.isShowVisualizationLayer) ? _c('map-header', {
    attrs: {
      "visualizationLayerType": _vm.visualizationLayerType,
      "mapSize": _vm.mapAdjustSize
    }
  }) : _vm._e(), _vm._v(" "), _c('map-image')], 1), _vm._v(" "), _c('svg', {
    staticClass: "visualizationPinLayer",
    attrs: {
      "viewBox": _vm.viewBox,
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('svg-defs'), _vm._v(" "), (_vm.visualizationLayerType == 'light') ? _c('visualization-layer-light') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'temperature') ? _c('visualization-layer-temperature') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'humidity') ? _c('visualization-layer-humidity') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'eco2') ? _c('visualization-layer-eco2') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'sound') ? _c('visualization-layer-sound') : _vm._e(), _vm._v(" "), (_vm.visualizationLayerType == 'wind_speed') ? _c('visualization-layer-wind-speed') : _vm._e(), _vm._v(" "), _c('image', {
    attrs: {
      "width": "90",
      "height": "99",
      "transform": ("translate(17.02, -25.68) scale(" + (_vm.pxToSvgSize(90) / 90) + ")"),
      "xlink:href": require("@/assets/images/current_location.svg")
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2d0f4e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map.vue
// module id = 901
// module chunks = 0